import { render, staticRenderFns } from "./Permission.vue?vue&type=template&id=dd798a56&scoped=true"
import script from "./Permission.vue?vue&type=script&lang=js"
export * from "./Permission.vue?vue&type=script&lang=js"
import style0 from "./Permission.vue?vue&type=style&index=0&id=dd798a56&prod&scoped=true&lang=css"
import style1 from "./Permission.vue?vue&type=style&index=1&id=dd798a56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd798a56",
  null
  
)

export default component.exports